import * as types from './constants'

const defaultState = {
  address: {
    attributes: {},
    errors: {},
    editing: false
  },
  capacity: {
    attributes: []
  },
  operational_profile: {
    attributes: {},
    errors: {},
    editing: false
  }
}

const editingAddress = () => ({
  editing: true
})

const updateSection = (payload, errors = {}) => ({
  attributes: payload,
  editing: false,
  errors
})

export const handleLoaded = (payload) => ({
  address: updateSection(payload.address),
  capacity: updateSection(payload.capacity),
  operational_profile: updateSection(payload.operational_profile)
})

export const detailsReducer = (state = defaultState, action) => {
  switch (action.type) {
  case types.DETAILS_LOADED:
    return Object.assign(
      {},
      state,
      handleLoaded(action)
    )
  case types.DETAILS_ADDRESS_EDITING:
    return Object.assign(
      {},
      state,
      editingAddress()
    )
  default:
    return state
  }
}

export default detailsReducer


// WEBPACK FOOTER //
// ./src/gov-care-registration-details/reducer.js